import { Link, NavLink } from "react-router-dom";
import "./topbar.scss";

export default function Topbar() {
  return (
    <header className="topbar">
      <span className="progress" aria-hidden="true"></span>
      <nav className="topbar-pill" aria-label="Primary">
        <Link className="brand" to="/" aria-label="Kareem Elewa, home">
          <span className="brand-full">Kareem Elewa</span>
          <span className="brand-short">KE</span>
        </Link>
        <div className="links">
          <a href="/#about">About</a>
          <a href="/#journey">Journey</a>
          <NavLink to="/experience">Experience</NavLink>
          <NavLink to="/projects">Projects</NavLink>
        </div>
        <a className="btn primary small plain contact-link" href="/#contact">Contact</a>
      </nav>
    </header>
  );
}
